import React from 'react';
import MobileListCard from './MobileListCard';

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  const day = ('0' + date.getDate()).toString().slice(-2);
  const month = ('0' + (date.getMonth() + 1)).toString().slice(-2);
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const CompanyMobileCard = ({ item, onOpen, isSelected }) => {
  const dateRejoint = formatDate(item.createdAt);
  
  // Construire les metaItems en excluant le groupe s'il est vide
  const metaItems = [];
  
  // Toujours ajouter la date
  metaItems.push({
    label: 'Rejoint le',
    value: dateRejoint,
  });

  // Préparer le badge du groupe s'il existe
  const groupeBadge = 
    item.bigAccounts && 
    Array.isArray(item.bigAccounts) && 
    item.bigAccounts.length > 0 ? (
      <span className="inline-flex items-center rounded-md px-2 py-1 text-sm ring-1 ring-inset bg-gray-50 text-gray-600 ring-gray-500/10">
        {item.bigAccounts.join(', ')}
      </span>
    ) : null;

  return (
    <MobileListCard
      title={item.name_commercial}
      onClick={() => onOpen(item._id)}
      isSelected={isSelected}
      metaItems={metaItems}
      topRightBadge={groupeBadge}
      className="company-mobile-card"
    />
  );
};

export default CompanyMobileCard;

